import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NotificationDemoModule } from './components/notification-demo/notification-demo.module';
import { PeopleMultiSelectModule } from './components/index-people-select/people-multiselect.module';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { PdfGeneratorComponent } from './components/pdf-generator/pdf-generator.component';

@NgModule({
    declarations: [
        SafeUrlPipe,
        PdfGeneratorComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        NotificationDemoModule,
        PeopleMultiSelectModule,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        NotificationDemoModule,
        PeopleMultiSelectModule,
        SafeUrlPipe,
        PdfGeneratorComponent
    ]
})
export class SharedModule { } 